import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["aria-label", "children", "depth", "divider", "headingText", "value"];
import unescapedText from 'I18n/utils/unescapedText';
import styled from 'foundations-theming/utils';
import { Text } from '../../../components/Text/Text';
import { SideNavContextProvider } from './SideNavContext';
import { View } from '../../../components/View';
import { HR } from '../HR/HR';
import { Children } from 'react';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUl = styled.ul.withConfig({
  displayName: "SideNav__StyledUl",
  componentId: "sc-1jiwhl0-0"
})(({
  depth,
  theme
}) => {
  return {
    listStyle: 'none',
    paddingLeft: 0,
    marginTop: theme.space['0'],
    lineHeight: theme.typography['detail-200'].lineHeight,
    marginBottom: depth === 0 ? 0 : undefined
  };
});
const StyledNav = styled.nav.withConfig({
  displayName: "SideNav__StyledNav",
  componentId: "sc-1jiwhl0-1"
})(({
  $cssStyles
}) => {
  return Object.assign({}, $cssStyles);
});
export const SideNav = _ref => {
  let {
      'aria-label': ariaLabel,
      children,
      depth = 0,
      divider = false,
      headingText,
      value
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isTopLevelNav = depth === 0;
  const computedAriaLabel = ariaLabel || headingText || unescapedText('ui.UISideNav.navigationLandmark');
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsxs(SideNavContextProvider, {
    depth: depth,
    value: value,
    children: [divider && /*#__PURE__*/_jsx(View, {
      paddingBlockEnd: "200",
      children: /*#__PURE__*/_jsx(HR, {
        distance: "sm"
      })
    }), /*#__PURE__*/_jsxs(StyledNav, Object.assign({
      "aria-label": computedAriaLabel,
      as: isTopLevelNav ? 'nav' : 'div'
    }, domProps, {
      $cssStyles: cssStyles,
      children: [headingText && /*#__PURE__*/_jsx(View, {
        paddingBlockEnd: "200",
        children: /*#__PURE__*/_jsx(Text, {
          as: "h5",
          children: headingText
        })
      }), /*#__PURE__*/_jsx(StyledUl, {
        depth: depth,
        children: Children.map(children, child => {
          if (!child) {
            return null;
          }
          return child;
        })
      })]
    }))]
  });
};